import { Box, Container } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { GangForm } from '@operations/features/gang/components/organisms/GangForm'
import { GangFormHeader } from '@operations/features/gang/components/organisms/GangFormHeader'
import { useGangMessageHandler } from '@operations/features/gang/hooks/useGangMessageHandler'
import { IGangFormData } from '@operations/features/gang/models/gang.model'

import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, useAsyncFetch, useFormStore, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router'

export const GangFormPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { id } = useParams<{ id: string }>()
    const navigate = useNavigate()
    const { appStore, gangStore } = useOperationsStore()
    const { getExceptionMessage, getSuccessMessage } = useGangMessageHandler()
    const formStore = useFormStore<IGangFormData>()

    const gangId = id ? Number(id) : null

    useAsyncFetch(
      async () => {
        await gangStore.fetchData()
        gangStore.setSelectedGang(gangStore.items.find(x => x.id === gangId))
      },
      [gangId, gangStore],
      { onError: error => appStore.setShowAlert('error', getExceptionMessage(error)) },
    )

    const onSubmit = async () => {
      try {
        const data: IGangFormData = formStore.data

        if (formStore.validate()) {
          if (gangId) await gangStore.updateGang({ ...data, id: gangId })
          else await gangStore.createGang(data)

          appStore.setShowAlert('success', getSuccessMessage())
          navigate(PATHS.masterData.gang.url)
          gangStore.setSelectedGang(undefined)
        }
      } catch (error) {
        appStore.setShowAlert('error', getExceptionMessage(error))
      }
    }

    return (
      <Box
        sx={{
          bgcolor: theme.palette.grey[100],
          minHeight: '100%',
        }}
      >
        <GangFormHeader isEdit={!!gangId} onSubmit={onSubmit} />

        <Container sx={{ paddingY: 2 }}>
          {(gangId === gangStore.selectedGang?.id || (!gangId && !gangStore.selectedGang)) && (
            <GangForm
              formStore={formStore}
              gang={gangStore.selectedGang}
              gangNames={gangStore.gangNames}
            />
          )}
        </Container>
      </Box>
    )
  }),
)
